import {IBenefitsRowProps} from "@housebets/housebets-x-package/lib/components/feature/rewards/Benefits/BenefitsRow/types";
import {useState} from "react";

const bronzeData: IBenefitsRowProps[] = [
    {
        title: "benefits.bronze.instantRakeback.title",
        description: "benefits.bronze.instantRakeback.description",
        icon: "/img/rewards/benefits/1.png",
    },
    {
        title: "benefits.bronze.dailyRakeback.title",
        description: "benefits.bronze.dailyRakeback.description",
        icon: "/img/rewards/benefits/2.png",
    },
    {
        title: "benefits.bronze.levelUpBonus.title",
        description: "benefits.bronze.levelUpBonus.description",
        icon: "/img/rewards/benefits/1.png",
    },
];

const silverData: IBenefitsRowProps[] = [
    ...bronzeData,
    {
        title: "benefits.silver.weeklyBonus.title",
        description: "benefits.silver.weeklyBonus.description",
        icon: "/img/rewards/benefits/2.png",
    },
];

const goldData: IBenefitsRowProps[] = [
    ...silverData,
    {
        title: "benefits.gold.personalHost.title",
        description: "benefits.gold.personalHost.description",
        icon: "/img/rewards/benefits/1.png",
    },
    {
        title: "benefits.gold.enhancedWeeklyBonus.title",
        description: "benefits.gold.enhancedWeeklyBonus.description",
        icon: "/img/rewards/benefits/2.png",
    },
];

const platinumData: IBenefitsRowProps[] = [
    ...bronzeData,
    {
        title: "benefits.platinum.personalHost.title",
        description: "benefits.platinum.personalHost.description",
        icon: "/img/rewards/benefits/1.png",
    },
    {
        title: "benefits.platinum.superiorWeeklyBonus.title",
        description: "benefits.platinum.superiorWeeklyBonus.description",
        icon: "/img/rewards/benefits/2.png",
    },
    {
        title: "benefits.platinum.monthlyBonus.title",
        description: "benefits.platinum.monthlyBonus.description",
        icon: "/img/rewards/benefits/2.png",
    },
];

const pearlData: IBenefitsRowProps[] = [
    ...bronzeData,
    {
        title: "benefits.pearl.personalHost.title",
        description: "benefits.pearl.personalHost.description",
        icon: "/img/rewards/benefits/1.png",
    },
    {
        title: "benefits.pearl.maxedWeeklyBonus.title",
        description: "benefits.pearl.maxedWeeklyBonus.description",
        icon: "/img/rewards/benefits/2.png",
    },
    {
        title: "benefits.pearl.tailoredMonthlyBonus.title",
        description: "benefits.pearl.tailoredMonthlyBonus.description",
        icon: "/img/rewards/benefits/2.png",
    },
];

const onyxData: IBenefitsRowProps[] = [
    {
        title: "benefits.onyx.instantRakeback.title",
        description: "benefits.onyx.instantRakeback.description",
        icon: "/img/rewards/benefits/1.png",
    },
    {
        title: "benefits.onyx.dailyRakeback.title",
        description: "benefits.onyx.dailyRakeback.description",
        icon: "/img/rewards/benefits/2.png",
    },
    {
        title: "benefits.onyx.levelUpBonus.title",
        description: "benefits.onyx.levelUpBonus.description",
        icon: "/img/rewards/benefits/1.png",
    },
    {
        title: "benefits.onyx.personalHost.title",
        description: "benefits.onyx.personalHost.description",
        icon: "/img/rewards/benefits/1.png",
    },
    {
        title: "benefits.onyx.maxedWeeklyBonus.title",
        description: "benefits.onyx.maxedWeeklyBonus.description",
        icon: "/img/rewards/benefits/2.png",
    },
    {
        title: "benefits.onyx.tailoredMonthlyBonus.title",
        description: "benefits.onyx.tailoredMonthlyBonus.description",
        icon: "/img/rewards/benefits/2.png",
    },
];

const diamondData: IBenefitsRowProps[] = [
    {
        title: "benefits.diamond.instantRakeback.title",
        description: "benefits.diamond.instantRakeback.description",
        icon: "/img/rewards/benefits/1.png",
    },
    {
        title: "benefits.diamond.dailyRakeback.title",
        description: "benefits.diamond.dailyRakeback.description",
        icon: "/img/rewards/benefits/2.png",
    },
    {
        title: "benefits.diamond.levelUpBonus.title",
        description: "benefits.diamond.levelUpBonus.description",
        icon: "/img/rewards/benefits/1.png",
    },
    {
        title: "benefits.diamond.personalHost.title",
        description: "benefits.diamond.personalHost.description",
        icon: "/img/rewards/benefits/1.png",
    },
    {
        title: "benefits.diamond.eliteWeeklyBonus.title",
        description: "benefits.diamond.eliteWeeklyBonus.description",
        icon: "/img/rewards/benefits/2.png",
    },
    {
        title: "benefits.diamond.ultimateMonthlyBonus.title",
        description: "benefits.diamond.ultimateMonthlyBonus.description",
        icon: "/img/rewards/benefits/2.png",
    },
];

const palladiumData: IBenefitsRowProps[] = [
    {
        title: "benefits.palladium.instantRakeback.title",
        description: "benefits.palladium.instantRakeback.description",
        icon: "/img/rewards/benefits/1.png",
    },
    {
        title: "benefits.palladium.dailyRakeback.title",
        description: "benefits.palladium.dailyRakeback.description",
        icon: "/img/rewards/benefits/2.png",
    },
    {
        title: "benefits.palladium.levelUpBonus.title",
        description: "benefits.palladium.levelUpBonus.description",
        icon: "/img/rewards/benefits/1.png",
    },
    {
        title: "benefits.palladium.personalHost.title",
        description: "benefits.palladium.personalHost.description",
        icon: "/img/rewards/benefits/1.png",
    },
    {
        title: "benefits.palladium.eliteWeeklyBonus.title",
        description: "benefits.palladium.eliteWeeklyBonus.description",
        icon: "/img/rewards/benefits/2.png",
    },
    {
        title: "benefits.palladium.ultimateMonthlyBonus.title",
        description: "benefits.palladium.ultimateMonthlyBonus.description",
        icon: "/img/rewards/benefits/2.png",
    },
    {
        title: "benefits.palladium.superVipTreatment.title",
        description: "benefits.palladium.superVipTreatment.description",
        icon: "/img/rewards/benefits/1.png",
    },
];

const castleData: IBenefitsRowProps[] = [
    {
        title: "benefits.castle.allPalladiumPerks.title",
        description: "benefits.castle.allPalladiumPerks.description",
        icon: "/img/rewards/benefits/1.png",
    },
    {
        title: "benefits.castle.levelUpBonus.title",
        description: "benefits.castle.levelUpBonus.description",
        icon: "/img/rewards/benefits/1.png",
    },
    {
        title: "benefits.castle.legendaryWeeklyBonus.title",
        description: "benefits.castle.legendaryWeeklyBonus.description",
        icon: "/img/rewards/benefits/2.png",
    },
    {
        title: "benefits.castle.topVipExperience.title",
        description: "benefits.castle.topVipExperience.description",
        icon: "/img/rewards/benefits/1.png",
    },
];

interface IBenefitTableData {
    bronze: IBenefitsRowProps[];
    silver: IBenefitsRowProps[];
    gold: IBenefitsRowProps[];
    platinum: IBenefitsRowProps[];
    pearl: IBenefitsRowProps[];
    onyx: IBenefitsRowProps[];
    diamond: IBenefitsRowProps[];
    palladium: IBenefitsRowProps[];
    castle: IBenefitsRowProps[];
}

export const useBenefitsTableData = () => {
    const [tableData] = useState<IBenefitTableData>({
        bronze: bronzeData,
        silver: silverData,
        gold: goldData,
        platinum: platinumData,
        pearl: pearlData,
        onyx: onyxData,
        diamond: diamondData,
        palladium: palladiumData,
        castle: castleData,
    });

    return {
        benefitsData: tableData,
    };
};
